import { Pipe, PipeTransform } from '@angular/core';

import size from 'lodash/size';

@Pipe({
  name: 'fraction',
})
export class FractionPipe implements PipeTransform {
  transform(value: number): string {
    let fraction: string;

    if (value > 0) {
      // prepare the whole number
      const wholeNumber: number = Math.floor(value);
      if (wholeNumber > 0) {
        fraction = wholeNumber.toString();
      } else {
        fraction = '';
      }

      // prepare the fraction
      const decimal: number = value - wholeNumber;
      let decimalStr: string;
      if (decimal > 0) {
        decimalStr = '1/' + 1 / decimal;
        fraction += size(fraction) ? ' & ' + decimalStr : decimalStr;
      }
    }

    return fraction;
  }
}
